import { snakeToCamelCase } from './common';
import { ItemFilter } from '../../graphql/types';

const integerFields = new Set([
  'price_from',
  'price_to',
  'area_from',
  'area_to',
  'initial_payment_from',
  'initial_payment_to',
  'monthly_payment_from',
  'monthly_payment_to'
]);

export const parseVippedFiltersFromQuery = (query: unknown): ItemFilter => {
  if (!query || typeof query !== 'object') return {} as ItemFilter;

  const { id, nextInternalLocale, ...filterParams } = query;
  return Object.fromEntries(
    Object.entries(filterParams).map(([key, value]) => {
      const newKey = key.replace(/q\[([^\]]*)\]|\[\]/g, '$1');
      const strValue = value as string | string[];
      let newValue: unknown;

      if (Array.isArray(strValue)) {
        newValue = strValue;
      } else if (newKey === 'room_ids') {
        newValue = [strValue];
      } else if (integerFields.has(newKey)) {
        newValue = +strValue;
      } else {
        newValue = !Number.isNaN(+strValue) ? strValue : strValue === 'true';
      }

      return [
        snakeToCamelCase(newKey),
        newKey === 'building_type' ? value : newValue
      ];
    })
  ) as ItemFilter;
};
